import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';
import DotsLoading from '../../../../../components/dotsLoading';
import CustomSearchBox from '../../../../../components/mazraeKit/customSearchBox';
import NoData from '../../../../../components/noData';
import SpinnerLoading from '../../../../../components/SpinnerLoading';
import useGetListBrand from '../../../../../services/hookService/getListBrand/useGetListBrand';
import {RootState} from '../../../../../store/redux';
import {addRegisterAdvertisement} from '../../../../../store/redux/advertisementRegisteration';
import useDebounce from '../../../../../utilities/hooks/useDebounce/useDebounce';
import useInfiniteScroll from '../../../../../utilities/hooks/useInfiniteScroll';

function BrandSelect() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {state} = useLocation();
  const [inputValue, setInputValue] = useState('');
  const debouncedValue = useDebounce<string>(inputValue, 1000);

  const {brand_name, input_group, prevRoute, sub_input, input} = useSelector(
    (state: RootState) => state.advertisementRegisteration,
  );

  const {data, isLoading, fetchNextPage, hasNextPage, isFetching} =
    useGetListBrand({
      search: debouncedValue,
      input_guid: input?.guid,
      sub_input_guid: sub_input?.guid,
    });

  const loaderRef = useInfiniteScroll({
    isLoading,
    fetchNextPage,
    isFetchingNextPage: isFetching,
    hasNextPage,
  });

  return (
    <div className="flex flex-col h-full px-3">
      <div className="flex h-[56px] w-full justify-between items-center text-md text-black">
        <div className="flex items-center">
          <span>نام تجاری</span>
        </div>
        <i
          className="text-xl icon-nameClose-remove font-Bold"
          onClick={() => {
            navigate(prevRoute ?? state?.backRoute, {
              state: {
                brand_name,
              },
            });
          }}
        />
      </div>
      <hr className="mx-2 mt-0 text-gray-300" />
      <div className="mt-2 ">
        <CustomSearchBox
          placeholder="جستجو"
          type="text"
          value={inputValue}
          inputCustomClass="!pr-4"
          preIcon="icon-nameSearch"
          onChange={e => setInputValue(e.target.value)}
          {...{inputValue, setInputValue}}
        />
      </div>
      <div className="flex flex-col flex-1 overflow-y-auto">
        {!isLoading && data?.length === 0 && (
          <div className="grid min-h-full grid-cols-1 mx-auto place-content-center">
            <NoData />
          </div>
        )}

        {isLoading ? (
          <div className="flex items-center justify-center h-full">
            <DotsLoading />
          </div>
        ) : (
          data?.map((item, index) => (
            <span
              key={item.guid ?? item.id ?? index}
              className="py-4 border-b"
              onClick={() => {
                navigate('sub-brand', {
                  state: item,
                });
                dispatch(
                  addRegisterAdvertisement({
                    brand_name: item.name,
                  }),
                );
              }}
            >
              {item.name}
            </span>
          ))
        )}
        <div ref={loaderRef} />
        {!isLoading && isFetching && (
          <SpinnerLoading className="mx-auto my-4" />
        )}
      </div>
    </div>
  );
}

export default BrandSelect;
